import { Stack, styled } from '@mui/material';

import { LiveSearchBox } from '../../../../../../../components/atoms/LiveSearchBox';
import { SelectMenu } from '../../../../../../../components/atoms/SelectMenu';

export const StyledStack = styled(Stack)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
  max-width: 300px;
`);

export const StyledLiveSearchBox = styled(LiveSearchBox)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);

export const StyledSelectMenu = styled(SelectMenu)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);